import { useEffect, useRef } from "react";

import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";

import AmplitudeProvider from "~/AmplitudeProvider";
import Dashboard from "~/v2/pages/dashboard/home";
import { Path } from "~/v2/path";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { isPaperOrOnboarding } from "~/v2/utils";

export default function Overview() {
  const { product, currentAccount, setCurrentAccount, paperAccounts } =
    useAccountContext();
  const redirectedAccountId = useRef<string>();
  const onboardingPaperAccountId =
    product === "live" && isPaperOrOnboarding(currentAccount)
      ? [...paperAccounts].sort((first, second) =>
          first.id.localeCompare(second.id),
        )[0]?.id
      : undefined;

  useEffect(() => {
    AmplitudeProvider.dispatchPageVisit();
  }, []);

  useEffect(() => {
    if (
      onboardingPaperAccountId &&
      redirectedAccountId.current !== onboardingPaperAccountId
    ) {
      redirectedAccountId.current = onboardingPaperAccountId;
      setCurrentAccount(onboardingPaperAccountId);
    }
  }, [onboardingPaperAccountId, setCurrentAccount]);

  if (onboardingPaperAccountId) {
    return <Redirect to={Path.ROUTE_DASHBOARD} />;
  }

  return (
    <div className="dashboard-container">
      <Helmet title={`Alpaca – Dashboard`} />
      <Dashboard />
    </div>
  );
}
